export const id = {
  // Common
  "common.back": "Kembali",
  "common.cancel": "Batal",
  "common.noItems": "Tidak ada item",
  "common.loading": "Memuat...",
  
  // Header
  "nav.features": "Fitur",
  "nav.howItWorks": "Cara Kerja",
  "nav.pricing": "Harga",
  "nav.faq": "FAQ",
  "nav.testimonials": "Showcase",
  "nav.contact": "Kontak",
  "button.getStarted": "Mulai",
  "button.loading": "Memuat...",

  // Auth related
  "auth.signIn": "Masuk",
  "auth.redirecting": "Mengalihkan...",
  "auth.continueWithGoogle": "Lanjutkan dengan Google",
  "auth.continueWithGithub": "Lanjutkan dengan GitHub",
  "auth.or": "ATAU",
  "auth.consent.prefix": "Dengan melanjutkan, Anda menyetujui",
  "auth.consent.terms": "Syarat",
  "auth.consent.and": "dan",
  "auth.consent.privacy": "Kebijakan Privasi",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "Asisten Komunikasi AI",
  "hero.subtitle": "Ubah percakapan Anda dengan respons cerdas yang sadar konteks untuk membantu Anda berkomunikasi lebih efektif dalam situasi apapun.",
  "hero.cta.primary": "Coba Gratis",
  "hero.cta.secondary": "Lihat Demo",
  "hero.cta.tryNow": "Mulai Gratis",
  "hero.cta.learnMore": "Pelajari Lebih Lanjut",
  "hero.cta.getStarted": "Mulai Gratis",
  "hero.preview.primary": "Perbaiki Nada",
  "hero.preview.secondary": "Terjemahkan",
  "hero.preview.tone": "Ramah",
  "hero.preview.target": "Klien",
  "hero.hook": "Bergabunglah dengan ribuan pengguna yang meningkatkan komunikasi mereka setiap hari.",
  "hero.headline": "Asisten Komunikasi AI",
  "hero.subheadline": "Ubah ide kasar menjadi balasan yang halus dan sadar konteks dalam hitungan detik.",
  
  // Stats
  "stats.users": "Pengguna",
  "stats.replies": "Balasan",
  "stats.languages": "Bahasa",

  // Main Title
  "main.title": "Ubah Setiap Balasan Menjadi Peluang",

  // Footer Section
  "footer.company": "Perusahaan",
  "footer.product": "Produk",
  "footer.support": "Dukungan",
  "footer.legal": "Legal",
  "footer.contactSupport": "Hubungi Dukungan",
  "footer.helpCenter": "Pusat Bantuan",
  "footer.apiDocs": "Dokumentasi API",
  "footer.statusPage": "Halaman Status",
  "footer.privacyPolicy": "Kebijakan Privasi",
  "footer.termsOfService": "Syarat Layanan",
  "footer.cookiePolicy": "Kebijakan Cookie",
  "footer.refundPolicy": "Kebijakan Pengembalian",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Dukungan",

  // Features Section
  "features.badge": "Fitur Canggih",
  "features.title": "Semua yang Anda Butuhkan untuk Komunikasi yang Lebih Baik",
  "features.subtitle": "Alat komprehensif yang dirancang untuk membuat setiap percakapan lebih efektif dan profesional.",
  "features.scenario.title": "Template Skenario",
  "features.scenario.description": "Template siap pakai untuk komunikasi tempat kerja, pribadi, akademik, dan profesional.",
  "features.custom.title": "Input Kustom",
  "features.custom.description": "Tempel pesan atau konten apa pun dan dapatkan respons yang sesuai konteks.",
  "features.instant.title": "Kurangi waktu respons 90%",
  "features.instant.description": "Dapatkan balasan buatan AI dalam hitungan detik. Tanpa menunggu, hanya hasil.",
  "features.copy.title": "Salin & Bagikan Satu Klik",
  "features.copy.description": "Salin respons secara instan atau bagikan langsung dari platform.",

  // How It Works Section
  "howItWorks.badge": "Cara Kerja",
  "howItWorks.title": "Tiga Langkah Sederhana untuk Komunikasi yang Lebih Baik",
  "howItWorks.subtitle": "Proses yang disederhanakan kami memudahkan pembuatan respons profesional untuk situasi apa pun.",
  "howItWorks.step1.title": "Pilih Skenario",
  "howItWorks.step1.description": "Pilih skenario komunikasi yang paling sesuai dengan kebutuhan Anda.",
  "howItWorks.step2.title": "Tempel Konten",
  "howItWorks.step2.description": "Tambahkan pesan atau konten yang perlu Anda tanggapi.",
  "howItWorks.step3.title": "Dapatkan Respons AI",
  "howItWorks.step3.description": "Terima respons profesional dan kontekstual dalam hitungan detik.",

  // Pricing Section
  "pricing.title": "Harga",
  "pricing.subtitle": "Pilih paket yang sesuai dengan kebutuhan komunikasi Anda",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/bulan",
  "pricing.free.description": "Sempurna untuk mencoba layanan kami",
  "pricing.pro.description": "Ideal untuk profesional dan pengguna sering",
  "pricing.business.description": "Untuk tim dan organisasi",
  "pricing.popular": "Paling Populer",
  "pricing.free.feature1": "10 balasan per bulan",
  "pricing.free.feature2": "Skenario dasar",
  "pricing.free.feature3": "Tentukan & gunakan template",
  "pricing.free.feature4": "Catatan balasan historis",
  "pricing.pro.feature1": "200 balasan per bulan",
  "pricing.pro.feature2": "Skenario dasar+kustom",
  "pricing.pro.feature3": "Tentukan & gunakan template",
  "pricing.pro.feature4": "Catatan balasan historis",
  "pricing.pro.feature5": "Kustomisasi lanjutan",
  "pricing.business.feature1": "Balasan tak terbatas",
  "pricing.business.feature2": "Kolaborasi tim",
  "pricing.business.feature3": "Skenario dasar+kustom",
  "pricing.business.feature4": "Tentukan & gunakan template",
  "pricing.business.feature5": "Catatan balasan historis",
  "pricing.business.feature6": "Kustomisasi lanjutan",
  "pricing.cta.trial": "Mulai Coba Gratis",
  "pricing.cta.subscribe": "Berlangganan",
  "pricing.cta.contact": "Hubungi Penjualan",
  "pricing.cta.current": "Paket Saat Ini",
  "pricing.currentPlan": "Paket Saat Ini:",
  "pricing.endDate": "Tanggal akhir paket saat ini:",
  "pricing.autoRenewalDate": "Tanggal pembaruan otomatis paket saat ini:",
  "pricing.answersLeft": "Sisa balasan:",
  "pricing.planName.free": "Paket Free",
  "pricing.planName.proMonthly": "Paket Pro-Bulanan",
  "pricing.planName.proYearly": "Paket Pro-Tahunan",
  "pricing.planName.maxMonthly": "Paket Enterprise-Bulanan",
  "pricing.planName.maxYearly": "Paket Enterprise-Tahunan",
  "pricing.autoRenews": "Jumlah balasan Anda diperbarui otomatis pada:",
  "pricing.needMore": "Perlu balasan lebih?",
  "pricing.upgradeBelow": "Tingkatkan paket Anda di bawah",
  "pricing.doNotRollOver": "Balasan yang tidak digunakan tidak akan ditransfer",
  "pricing.willCancelOn": "Akan dibatalkan pada:",
  "pricing.downgradeScheduled": "Penurutan jadwal. Akan beralih ke",
  "pricing.on": "pada:",
  "pricing.upgradeImmediateTitle": "Paket ditingkatkan",
  "pricing.upgradeImmediateDesc": "Paket baru Anda sekarang aktif.",
  "pricing.downgradeScheduledTitle": "Penurutan dijadwalkan",
  "pricing.downgradeScheduledDesc": "Paket Anda akan berubah pada pembaruan berikutnya.",
  "pricing.cancelScheduledTitle": "Pembatalan dijadwalkan",
  "pricing.cancelScheduledDesc": "Paket Anda akan berakhir pada tanggal akhir periode.",
  "pricing.cancelResumedTitle": "Pembatalan dihapus",
  "pricing.cancelResumedDesc": "Langganan Anda akan terus diperbarui.",
  "pricing.cancelPendingDowngrade": "Batal",
  "pricing.pendingDowngradeCanceledTitle": "Penurutan tertunda dibatalkan",
  "pricing.pendingDowngradeCanceledDesc": "Paket Anda akan tetap tidak berubah.",
  "pricing.pendingDowngradeCancelFailedTitle": "Pembatalan gagal",
  "pricing.pendingDowngradeCancelFailedDesc": "Tidak dapat membatalkan penurutan tertunda. Silakan coba lagi.",
  "pricing.cancelPendingDowngradeProcessing": "Memproses...",
  "pricing.scheduled": "Dijadwalkan",
  "pricing.processing": "Memproses...",
  "pricing.getMoreReplies": "Dapatkan Balasan Lebih",
  "pricing.oneTimeTitle": "Dapatkan lebih banyak balasan ke akun Anda",
  "pricing.oneTimeAmountLabel": "Jumlah (USD)",
  "pricing.repliesUnit": "Balasan",
  "pricing.oneTimeNotice": "Jumlah balasan yang Anda beli berlaku untuk siklus bulanan saat ini. Langganan berbayar aktif diperlukan untuk menggunakannya dan balasan yang tidak digunakan tidak akan ditransfer.",
  "pricing.cancel": "Batal",
  "pricing.proceed": "Lanjutkan",
  "pricing.confirmUpgradeTitle": "Konfirmasi Peningkatan",
  "pricing.confirmDowngradeTitle": "Konfirmasi Penurunan",
  "pricing.confirmUpgradeDesc": "Anda akan meningkatkan paket Anda. Perubahan berlaku segera dan biaya proporsional (atau kredit) dapat berlaku.",
  "pricing.confirmDowngradeDesc": "Anda akan menjadwalkan penurunan. Fitur Anda saat ini tetap berlaku sampai akhir periode penagihan saat ini.",
  "pricing.downgradeEffectNote": "Penurunan tidak mengembalikan siklus saat ini.",
  "pricing.downgradeApplyNextCycle": "Paket baru akan mulai secara otomatis saat pembaruan.",
  "pricing.confirmCancel": "Kembali",
  "pricing.confirmProceedUpgrade": "Tingkatkan Sekarang",
  "pricing.confirmProceedDowngrade": "Jadwalkan Penurunan",

  // FAQ Section
  "faq.title": "Pertanyaan Umum",
  "faq.subtitle": "Semua yang perlu Anda ketahui tentang communicate2win",
  "faq.q1": "Skenario komunikasi apa saja yang didukung?",
  "faq.a1": "Kami mendukung komunikasi tempat kerja, hubungan pribadi, korespondensi akademik, layanan pelanggan, penjangkauan penjualan, dan banyak skenario lainnya. AI kami beradaptasi dengan konteks dan nada yang diperlukan untuk setiap situasi.",
  "faq.q2": "Seberapa cepat respons dihasilkan?",
  "faq.a2": "AI kami menghasilkan respons dalam beberapa detik. Kami memprioritaskan kecepatan tanpa mengorbankan kualitas, memastikan Anda mendapatkan respons profesional secara instan.",
  "faq.q3": "Bisakah saya membatalkan langganan kapan saja?",
  "faq.a3": "Ya, Anda dapat membatalkan langganan kapan saja. Tidak ada komitmen jangka panjang, dan Anda dapat menurunkan atau meningkatkan paket sesuai kebutuhan.",
  "faq.q4": "Apakah data saya aman dan pribadi?",
  "faq.a4": "Ya, kami menerapkan langkah keamanan menyeluruh termasuk enkripsi, kontrol akses, dan audit keamanan rutin. Konten input Anda dan respons yang dihasilkan disimpan sebagai bagian dari riwayat pengguna Anda untuk mengaktifkan fitur seperti tinjauan respons dan pembuatan template. Anda dapat menghapus data riwayat kapan saja melalui pengaturan akun Anda.",
  "faq.q5": "Bagaimana jika Replies saya habis?",
  "faq.a5": "Pengguna Free harus menunggu hingga siklus bulanan berikutnya untuk kuota diperbarui. Setelah upgrade ke Pro, jika Replies habis Anda dapat membeli Replies tambahan satu kali; Replies tambahan ini hanya berlaku untuk siklus bulanan saat ini. Pengguna Enterprise memiliki Replies tanpa batas.",
  "faq.q6": "Bahasa apa saja yang didukung?",
  "faq.a6": "Saat ini, kami mendukung bahasa Inggris dengan rencana untuk memperluas ke bahasa Spanyol, Prancis, Jerman, dan bahasa utama lainnya. AI dapat menangani komunikasi multibahasa secara efektif.",

  // Testimonials Section
  "testimonials.title": "Showcase Komunikasi",
  "testimonials.subtitle": "Pesan publik, email, dan respons yang dipoles AI untuk menginspirasi Anda sendiri",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Direktur Pemasaran",
  "testimonials.sarah.quote": "communicate2win telah mengubah cara saya menangani komunikasi pelanggan. Responsnya profesional dan menghemat waktu saya berjam-jam setiap minggu.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Manajer Penjualan",
  "testimonials.michael.quote": "Template skenario tempat kerja sangat akurat. Tingkat respons saya meningkat 40% sejak menggunakan alat ini.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Kepala Kesuksesan Pelanggan",
  "testimonials.emily.quote": "Sempurna untuk menangani situasi pelanggan yang sulit. AI memahami konteks dan nada dengan sempurna.",
  "testimonials.more": "Klik galeri untuk menjelajahi showcase lengkap",

  // Interface Elements
  "interface.generating": "Membuat Respons...",
  "interface.generate": "Buat Respons AI",
  "interface.processing": "Memproses...",
  "interface.advancedOptions": "Opsi Lanjutan",
  "interface.clearInput": "Hapus Input",
  "interface.clearDescription": "Hapus Deskripsi",
  // Marquee / Logos
  "marquee.trusted": "Mitra / Dukungan",
  "marquee.aria": "Logo merek",

  // History and Showcase
  "history.shareToShowcase": "Bagikan ke Showcase",
  "history.showcased": "Ditampilkan",
  "history.shareConfirm": "Bagikan posting ini ke Showcase? Tindakan ini tidak dapat dibatalkan kecuali Anda menghapus posting tersebut.",
  "history.sharedBy": "Dibagikan oleh:",
  "interface.copy": "Salin",
  "interface.share": "Bagikan",
  "interface.shareResponse": "Bagikan Respons",
  "interface.shareNative": "Bagikan via Sistem",
  "interface.shareEmail": "Email",
  "interface.copyShareText": "Salin dengan Tautan",
  "interface.shareTextCopied": "Respons dan tautan disalin ke clipboard.",
  "interface.ready": "Siap Membuat",
  "interface.enterMessage": "Masukkan konten pesan Anda dan pilih skenario untuk memulai dengan respons berbasis AI.",
  "interface.fast": "Cepat",
  "interface.accurate": "Akurat",
  "interface.professional": "Profesional",
  "interface.translation": "Terjemahan",
  "interface.responseDescription": "Berikut adalah respons yang dipertimbangkan dan profesional yang disesuaikan dengan konteks:",
  "interface.multipleOptions": "Beberapa opsi respons:",
  "interface.option": "Opsi",
  "interface.noContent": "Tidak ada konten tersedia",

  // Placeholders
  "placeholder.message": "Tempel pesan yang Anda balas, konten email, atau teks yang Anda terima...",

  // Dropdowns
  "dropdown.useTemplates": "Gunakan Template",
  "dropdown.scenario": "Tanpa Skenario",
  "dropdown.target": "Tanpa Target",
  "dropdown.tone": "Tanpa Nada",

  // Scenario Options
  "scenario.email": "Email",
  "scenario.message": "Pesan",
  "scenario.workplace": "Tempat Kerja",
  "scenario.school": "Sekolah",
  "scenario.home": "Rumah",
  "scenario.business": "Bisnis",
  "scenario.academic": "Akademik",
  "scenario.social": "Sosial",
  "scenario.formal": "Formal",
  "scenario.casual": "Santai",
  "scenario.professional": "Profesional",
  "scenario.personal": "Pribadi",
  "scenario.customerService": "Layanan Pelanggan",
  "scenario.interview": "Wawancara",
  "scenario.presentation": "Presentasi",

  // Target Options
  "target.lover": "Kekasih",
  "target.friend": "Teman",
  "target.boss": "Bos",
  "target.colleague": "Rekan Kerja",
  "target.classmate": "Teman Sekelas",
  "target.parents": "Orang Tua",
  "target.child": "Anak",
  "target.teacher": "Guru",
  "target.student": "Siswa",
  "target.client": "Klien",
  "target.customer": "Pelanggan",
  "target.stranger": "Orang Asing",
  "target.family": "Keluarga",
  "target.sibling": "Saudara",
  "target.neighbor": "Tetangga",
  "target.mentor": "Mentor",
  "target.supplier": "Pemasok",
  "target.serviceProvider": "Penyedia Layanan",
  "target.partner": "Mitra",
  "target.subordinate": "Bawahan",

  // Tone Options
  "tone.humorous": "Humoris",
  "tone.serious": "Serius",
  "tone.happy": "Senang",
  "tone.angry": "Marah",
  "tone.mischievous": "Nakal",
  "tone.polite": "Sopan",
  "tone.casual": "Santai",
  "tone.formal": "Formal",
  "tone.friendly": "Ramah",
  "tone.confident": "Percaya Diri",
  "tone.apologetic": "Meminta Maaf",
  "tone.enthusiastic": "Antusias",

  // Status Messages
  "status.copied": "Tersalin!",
  "status.copyDescription": "Respons disalin ke clipboard.",
  "status.copyWithTranslationDescription": "Respons dan terjemahan disalin ke clipboard.",
  "status.success": "Respons berhasil dibuat.",
  "status.successWithTranslation": "Respons dibuat dengan terjemahan.",
  "status.successWithoutTranslation": "Respons berhasil dibuat.",
  "status.error": "Pembuatan gagal",
  "status.errorDescription": "Gagal membuat respons. Silakan coba lagi.",
  "status.enterContent": "Silakan masukkan konten",
  "status.enterContentDescription": "Tambahkan pesan yang ingin Anda balas.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Deskripsi (opsional)",
  "restriction.descriptionLabel": "Deskripsi (Hanya untuk pelanggan Pro / Enterprise)",
  "restriction.proMaxOnly": "* Hanya untuk pelanggan Pro / Enterprise",
  "restriction.desPrompt": "Masukkan konteks, informasi latar belakang, atau persyaratan khusus yang dapat membantu menghasilkan respons yang lebih baik...",

  // Demo functionality for non-logged-in users
  "demo.title": "Pilih pesan untuk dibalas",
  "demo.option1": "Pembuka penjualan (pendekatan dingin)",
  "demo.option2": "Menangani pertanyaan \"harga Anda tinggi\"",
  "demo.option3": "Perkenalan diri wawancara (versi 30 detik)",
  "demo.option4": "Balasan email",
  "demo.option5": "Tindak lanjut untuk prospek \"dibaca-tapi-tidak-dibalas\"",
  "demo.option6": "Elevator pitch (30 detik)",
  "demo.runDemo": "Jalankan Demo",
  "demo.inputContent": "Konten Input:",
  "demo.scenario": "Skenario:",
  "demo.target": "Target:",
  "demo.tone": "Nada:",
  "demo.description": "Deskripsi:",

  // Showcase Page
  "showcase.title": "Showcase Komunikasi",
  "showcase.subtitle": "Temukan komunikasi berbasis AI yang menginspirasi yang dibagikan oleh komunitas kami",
  "showcase.userPrefix": "Komunikasi publik oleh",
  "showcase.backAll": "Kembali ke Semua Showcase",
  "showcase.sortBy": "Urutkan berdasarkan:",
  "showcase.sort.newest": "Terbaru Dulu",
  "showcase.sort.oldest": "Terlama Dulu",
  "showcase.sort.scenario": "Berdasarkan Skenario",
  "showcase.sort.target": "Berdasarkan Target",
  "showcase.sort.tone": "Berdasarkan Nada",
  "showcase.filter.scenario": "Skenario:",
  "showcase.filter.target": "Target:",
  "showcase.filter.tone": "Nada:",
  "showcase.filter.all": "Semua",
  "showcase.loading": "Memuat showcase...",
  "showcase.loadingUser": "Memuat komunikasi pengguna...",
  "showcase.loadingMore": "Memuat lebih banyak...",
  "showcase.none.userTitle": "Belum ada komunikasi publik",
  "showcase.none.globalTitle": "Belum ada item showcase",
  "showcase.none.userDesc": "Pengguna ini belum membagikan komunikasi apa pun ke showcase.",
  "showcase.none.globalDesc": "Jadilah yang pertama membagikan komunikasi AI Anda ke showcase!",
  "showcase.messageDetails": "Detail Pesan",
  "showcase.field.date": "Tanggal",
  "showcase.field.scenario": "Skenario",
  "showcase.field.target": "Target",
  "showcase.field.tone": "Nada",
  "showcase.originalMessage": "Pesan Asli",
  "showcase.description": "Deskripsi",
  "showcase.aiResponse": "Respons AI",

  // Templates
  "templates.saveAsTemplate": "Simpan sebagai Template",
  "templates.saved": "Template Disimpan",
  "templates.saveSuccess": "Template berhasil disimpan",
  "templates.title": "Template Saya",
  "templates.new": "Template Baru",
  "templates.loading": "Memuat...",
  "templates.none": "Tidak ditemukan template",
  "templates.name": "Nama",
  "templates.scenario": "Skenario",
  "templates.target": "Target",
  "templates.tone": "Nada",
  "templates.description": "Deskripsi",
  "templates.save": "Simpan",
  "templates.saving": "Menyimpan...",
  "templates.delete": "Hapus Template",
  "templates.deleteConfirm": "Hapus template ini?",
  "templates.deleteFailed": "Gagal menghapus template",
  "templates.nameRequired": "* Silakan masukkan nama template",
  "templates.deleteSuccess": "Template berhasil dihapus",

  // History Modal additions
  "history.messageDetails": "Detail Pesan",
  "history.messageDetailsDesc": "Lihat dan kelola detail pesan Anda, termasuk input asli dan respons AI yang dihasilkan.",
  "history.field.date": "Tanggal",
  "history.field.scenario": "Skenario",
  "history.field.target": "Target",
  "history.field.tone": "Nada",
  "history.originalMessage": "Pesan Asli",
  "history.aiResponse": "Respons AI",
  "history.description": "Deskripsi",
  "history.listTitle": "Riwayat Pesan",
  "history.listDesc": "Jelajahi, filter, dan kelola riwayat percakapan Anda. Klik pada pesan apa pun untuk melihat detailnya.",
  "history.sortBy": "Urutkan berdasarkan:",
  "history.sort.newest": "Terbaru Dulu",
  "history.sort.oldest": "Terlama Dulu",
  "history.sort.scenario": "Berdasarkan Skenario",
  "history.sort.target": "Berdasarkan Target",
  "history.sort.tone": "Berdasarkan Nada",
  "history.filter.scenario": "Skenario:",
  "history.filter.target": "Target:",
  "history.filter.tone": "Nada:",
  "history.filter.all": "Semua",
  "history.loading": "Memuat riwayat...",
  "history.loadingMore": "Memuat lebih banyak...",
  "history.none": "Tidak ditemukan pesan",
  "history.showing": "Menampilkan {current} dari {total} pesan",
  "history.allLoaded": "Semua pesan dimuat",
  "history.scrollMore": "Gulir ke bawah untuk lebih banyak",
  "history.loadMoreButton": "Muat Lebih Banyak",
  "history.deleteMessage": "Hapus Pesan",
  "history.deleting": "Menghapus...",
  "history.deleteSuccess": "Catatan pesan berhasil dihapus",
  "history.deleteFailed": "Gagal menghapus catatan pesan, silakan coba lagi",
  "history.confirmDeleteTitle": "Konfirmasi Hapus",
  "history.confirmDeleteSubtitle": "Tindakan ini tidak dapat dibatalkan",
  "history.confirmDeleteDesc": "Apakah Anda yakin ingin menghapus catatan pesan ini?",
  "history.confirmDeleteAction": "Konfirmasi Hapus",
  "history.shareTitle": "Bagikan ke Showcase",
  "history.shareSubtitle": "Jadikan pesan ini publik",
  "history.sharing": "Membagikan...",
  "history.confirmShareAction": "Konfirmasi Bagikan",
  "history.shareSuccess": "Pesan berhasil dibagikan ke showcase",
  "history.shareFailed": "Gagal membagikan ke showcase, silakan coba lagi",
  "templates.saveFailed": "Gagal menyimpan template",

  // User Menu
  "userMenu.myAccount": "Akun Saya",
  "userMenu.history": "Riwayat",
  "userMenu.templates": "Template",
  "userMenu.signOut": "Keluar",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "Pratinjau Balasan AI",
  "hero.preview.scenarioLabel": "Skenario",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Pembuka penjualan",
  "demo.shortTitle.priceObjection": "Keberatan harga",
  "demo.shortTitle.interviewIntro": "Intro wawancara",
  "demo.shortTitle.emailReply": "Balasan email",
  "demo.shortTitle.followUp": "Tindak lanjut",
  "demo.shortTitle.elevatorPitch": "Pitch elevator",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "respons",
  "demoTabs.inputPrompt": "PROMPT INPUT",
  "demoTabs.context": "KONTEKS",
  "demoTabs.description": "Deskripsi",
  "demoTabs.generate": "Hasilkan",
  "demoTabs.aiOutput": "OUTPUT AI",
  "demoTabs.sample": "sampel",
  "demoTabs.streaming": "Token streaming...",
  "preview.section.scenarioTemplates.title": "Skenario & Template",
  "preview.section.scenarioTemplates.subtitle": "Pilih skenario dengan cepat atau terapkan template yang disimpan. Template mengisi deskripsi/target/nada sebelumnya sehingga Anda langsung memasuki generasi berkualitas tinggi.",
  "preview.section.customInputs.title": "Input Kustom",
  "preview.section.customInputs.subtitle": "Input inti + deskripsi opsional + pemilih Skenario/Target/Nada lanjutan. Gabungkan secara bebas untuk hasil yang sadar konteks.",
  "preview.section.cutReplyTime.title": "Kurangi Waktu Balas 90%",
  "preview.section.cutReplyTime.subtitle": "Bandingkan drafting manual vs bantuan AI. Opsi paralel + loop terjemahan atau revisi bawahan.",
  "preview.section.copyShare.title": "Salin & Bagikan Satu Klik",
  "preview.section.copyShare.subtitle": "Beberapa opsi disusun dengan tindakan atas terpadu: salin semua / bagikan / salin per opsi. Terjemahan ditambahkan secara otomatis.",
  "preview.templates.my": "Template Saya",
  "preview.templates.new": "Baru",
  "preview.manualFlow": "Alur Manual",
  "preview.aiAssisted": "Dibantu AI",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Rencanakan struktur & nada",
  "preview.manualFlow.step2": "Draf pembuka / hapus & tulis ulang",
  "preview.manualFlow.step3": "Sesuaikan sopan santun & tata bahasa",
  "preview.manualFlow.step4": "Cari kata & verifikasi terjemahan",
  "preview.manualFlow.step5": "Tempel ke aplikasi target",
  "preview.copyAll": "Salin Semua",
  "preview.share": "Bagikan",
  "preview.enPlusTranslation": "EN + Terjemahan",
  "preview.translationAppendNote": "(*) Terjemahan ditambahkan secara otomatis saat menyalin semua.",
  "preview.field.scenario": "Skenario",
  "preview.field.target": "Target",
  "preview.field.tone": "Nada",
  "preview.auto": "Otomatis",
  "preview.step.pasteOrTemplate": "Tempel permintaan atau pilih template",
  "preview.step.optionalDescription": "(Opsional) tambah deskripsi/skenario",
  "preview.step.pickOption": "Pilih salah satu opsi yang dihasilkan",
  "preview.step.copyShareTranslate": "Salin/bagikan/terjemahkan satu klik",
  "preview.time.manual": "5–8 menit",
  "preview.time.ai": "30–40 detik"
};